import React from 'react';

const About = () => {
  return (
    <section id="about" className="py-16 md:py-24 bg-gradient-to-br from-white via-purple-50/30 to-pink-50/30 relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute inset-0">
        <div className="absolute top-20 right-20 w-40 h-40 bg-purple-200/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-32 left-16 w-32 h-32 bg-pink-200/20 rounded-full blur-2xl"></div>
      </div>

      <div className="relative z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold bg-gradient-to-r from-purple-800 via-purple-600 to-pink-600 bg-clip-text text-transparent mb-4">
              About Khair Spa
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-purple-600 to-pink-600 mx-auto rounded-full"></div>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 mb-20 items-center">
            <div>
              <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-8 md:p-10 shadow-xl border border-purple-100">
                <h3 className="text-2xl md:text-3xl font-bold text-purple-800 mb-6">Our Story</h3>
                <p className="text-lg md:text-xl text-gray-700 mb-6 leading-relaxed">
                  Khair Spa is your premier destination for hair and beauty excellence. We specialize in sales of wigs, 
                  hair revamping, wigging, coloring, and hair ventilation. Our passion lies in bringing beauty to wigs 
                  and transforming your hair dreams into reality.
                </p>
                <p className="text-lg text-gray-600 leading-relaxed">
                  Located at 12 Ebony Road off Rumuola Road, Port Harcourt, we combine expertise with creativity 
                  to deliver exceptional hair and beauty services that enhance your natural beauty and boost your confidence.
                </p>
              </div>
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <img 
                  src="./p4.png" 
                  alt="Hair styling" 
                  className="w-full h-48 md:h-64 object-cover rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300"
                />
                <div className="bg-gradient-to-br from-purple-500 to-pink-500 p-6 rounded-2xl text-white text-center">
                  <div className="text-2xl md:text-3xl font-bold mb-2">500+</div>
                  <div className="text-sm font-medium">Happy Clients</div>
                </div>
              </div>
              <div className="space-y-4 mt-8">
                <div className="bg-gradient-to-br from-pink-500 to-purple-500 p-6 rounded-2xl text-white text-center">
                  <div className="text-2xl md:text-3xl font-bold mb-2">3+</div>
                  <div className="text-sm font-medium">Years Experience</div>
                </div>
                <img 
                  src="./p5.png" 
                  alt="Beauty treatment" 
                  className="w-full h-48 md:h-64 object-cover rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300"
                />
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
            <div className="group bg-white/80 backdrop-blur-sm p-8 rounded-3xl shadow-lg hover:shadow-xl transition-all duration-300 border border-purple-100 hover:border-purple-200">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-500 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </div>
              <h4 className="text-xl md:text-2xl font-bold text-purple-800 mb-4">Our Services</h4>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <div>
                    <span className="font-semibold">Wig Sales</span>
                    <span className="block text-sm text-gray-500">Premium Quality Wigs</span>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <div>
                    <span className="font-semibold">Hair Revamping</span>
                    <span className="block text-sm text-gray-500">Complete Hair Makeovers</span>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <div>
                    <span className="font-semibold">Hair Coloring</span>
                    <span className="block text-sm text-gray-500">Professional Color Treatments</span>
                  </div>
                </li>
              </ul>
            </div>

            <div className="group bg-white/80 backdrop-blur-sm p-8 rounded-3xl shadow-lg hover:shadow-xl transition-all duration-300 border border-purple-100 hover:border-purple-200">
              <div className="w-16 h-16 bg-gradient-to-br from-pink-500 to-purple-500 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h4 className="text-xl md:text-2xl font-bold text-purple-800 mb-4">Why Choose Us</h4>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-pink-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <div>
                    <span className="font-semibold hover:text-purple-800 transition-colors">Expert Hair Stylists</span>
                    <span className="block text-sm text-gray-500">Trained & Certified Professionals</span>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-pink-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <div>
                    <span className="font-semibold hover:text-purple-800 transition-colors">Premium Quality Products</span>
                    <span className="block text-sm text-gray-500">Top-Grade Hair & Beauty Products</span>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-pink-500 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <div>
                    <span className="font-semibold hover:text-purple-800 transition-colors">Personalized Service</span>
                    <span className="block text-sm text-gray-500">Tailored to Your Unique Style</span>
                  </div>
                </li>
              </ul>
            </div>

            <div className="group bg-white/80 backdrop-blur-sm p-8 rounded-3xl shadow-lg hover:shadow-xl transition-all duration-300 border border-purple-100 hover:border-purple-200">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-500 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h4 className="text-xl md:text-2xl font-bold text-purple-800 mb-4">Our Expertise</h4>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-3 flex-shrink-0"></span>
                  <span className="font-medium">Wig Styling & Fitting</span>
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-3 flex-shrink-0"></span>
                  <span className="font-medium">Hair Color Consultation</span>
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-3 flex-shrink-0"></span>
                  <span className="font-medium">Hair Restoration</span>
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-3 flex-shrink-0"></span>
                  <span className="font-medium">Beauty Treatments</span>
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-3 flex-shrink-0"></span>
                  <span className="font-medium">Custom Hair Solutions</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;